/**
 * Auth pages (/login, /signup, /verify-email, /reset-password) localized
 * copy. Re-export shim over /locales/{en,ht,fr,es}.json (auth key).
 * See /locales/README.md.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.auth,
  ht: ht.auth,
  fr: fr.auth,
  es: es.auth,
  'pt-BR': ptBR.auth,
  'zh-Hans': zhHans.auth,
}

export default COPY
